import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { QuestionType } from "@models/questionnaire/question-type";

@Injectable({providedIn: 'root'})
export class QuestionTypeClass extends AbstractClass {
  model: QuestionType;
  modelName = 'QuestionType';
  idName = "questionTypeID";
  langBase = "cms.components.questionnaire-type.";
  route = "cms/questionnaire-type";
  formCells = [];
  formTabs = [];
  formAccordion = [];
  tableCells: TableCell[] = [];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();

    this.model = {
      questionTypeID: 0,
      type: '',
      isActive: true,
      createdAt: new Date(),
      updatedAt: new Date(),
      createdBy: '',
    };
  }

}
